var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MonitorWrapper',{staticClass:"ht200-monitor"},[(_vm.stateOpt.isAlarm)?_c('Alarm'):_c('Normal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }